import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { lastValueFrom } from 'rxjs';
import { LoginService } from './login.service';
import { isPlatformServer } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  Url: string;
    constructor(
      public http: HttpClient,
      public loginService: LoginService,
      @Inject(PLATFORM_ID) platformId: object
    ) {
        this.Url = isPlatformServer(platformId) ? environment.apiServerUrl : GlobalConstants.apiURL;
    }

  public async GetMenu(IdCategoria: number) {
  const params = new HttpParams().set('IdCategoria', IdCategoria);
  return await lastValueFrom(
    this.http.get(this.Url + '/menu', { params })
  );
}



}
